// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"95":"480793fa","716":"6f579902","809":"c5295b07"}[chunkId] + ".js";
};